import { Controller } from "@hotwired/stimulus";
import toast from "lib/toast";

// Connects to data-controller="flash"
export default class extends Controller {
  connect() {
    toast(this.element.innerHTML, { type: this.element.dataset.notice });
  }
}
